import React from "react";
import ProfileAndSettings from "views/Config/Profiles/Common";
import SubscriberGroupProfilesHelpModal from "./Help";
import SubscriberGroupProfileSettingsHelpModal from "./SettingsHelp";
import { composedAPI } from "./api";
import subscriberGroupComposition from "./composition";

const ConfigSubscriberGroupProfiles = ({ ...settings }) => (
  <>
    <ProfileAndSettings
      {...subscriberGroupComposition}
      {...composedAPI}
      {...settings}
    />
    <SubscriberGroupProfilesHelpModal />
    <SubscriberGroupProfileSettingsHelpModal />
  </>
);

export default ConfigSubscriberGroupProfiles;
